import Flickity from "flickity";

export default class MobileCarousel {
  constructor(
    $el,
    options = {
      maxWidth: 1024,
    }
  ) {
    this.maxWidth = options.maxWidth;

    this.flickityOptions = {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: "true",
      cellAlign: "left",
      ...options.flickity,
    };
    this.$el = $el;

    if (window.innerWidth < this.maxWidth) {
      this.createCarousel();
    }

    window.addEventListener("resize", () => {
      const t = setTimeout(() => {
        this.onResize();
        clearTimeout(t);
      }, 250);
    });

    return this;
  }

  onResize() {
    if (window.innerWidth < this.maxWidth) {
      this.createCarousel();
      return;
    }

    if (this.carousel) {
      this.carousel.destroy();
    }
  }

  createCarousel() {
    if (!this.$el) {
      return;
    }

    this.carousel = new Flickity(this.$el, this.flickityOptions);
    const t = setTimeout(() => {
      this.carousel.resize();
      clearTimeout(t);
    }, 250);
  }
}
